import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
const bonuses = [{
  id: 'B1',
  title: 'Banco de Rutinas Anti-Rumiación',
  desc: 'Ejercicios mentales pre-armados enfocados en destrabar tu mente cuando entra en bucle.'
}, {
  id: 'B2',
  title: 'Guía de Desintoxicación Dopaminérgica',
  desc: 'El paso a paso para limpiar tu cerebro del exceso de estímulos digitales y pantallas.'
}, {
  id: 'B3',
  title: 'Entrenamientos de Emergencia Mental de 5 min',
  desc: 'Acciones de choque de aplicación inmediata para cuando sentís que la ansiedad se dispara.'
}, {
  id: 'B4',
  title: 'Diseñador de Entornos Calmos',
  desc: 'Cómo organizar tu espacio de trabajo y descanso para reducir la carga cognitiva gastando cero pesos.'
}, {
  id: 'B5',
  title: 'Protocolo de Higiene de Sueño Profundo',
  desc: 'Preparación detallada para apagar el cerebro a la noche y despertarte con energía real, no con alerta.'
}, {
  id: 'B6',
  title: 'Rastreador de Disciplina Emocional',
  desc: 'Planillas listas para registrar tus disparadores de ansiedad y medir tu progreso diario.'
}];
export function Bonuses() {
  return <section className="py-24 px-6 border-b border-ink/10" data-id="element-13">
      <div className="max-w-editorial mx-auto" data-id="element-14">
        <SectionHeader number="06" title="🎁 INCLUIDOS GRATIS: 6 BONOS ESTRATÉGICOS" subtitle="(Sin costo extra — Incluidos únicamente comprando hoy)" data-id="element-15" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12 mb-16" data-id="element-16">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-bone-dark/30 border border-ink/10 p-6 rounded-sm relative overflow-hidden group hover:border-ink/20 transition-colors" data-id="element-17">
              <div className="flex justify-between items-start mb-4" data-id="element-18">
                <span className="font-serif text-2xl text-ink/20 font-bold" data-id="element-19">
                  {bonus.id}
                </span>
                <span className="bg-sage/20 text-sage-dark text-xs font-bold px-2 py-1 rounded-sm uppercase tracking-wider text-ink" data-id="element-20">
                  GRATIS
                </span>
              </div>
              <h4 className="text-lg font-serif text-ink mb-3 leading-snug" data-id="element-21">
                {bonus.title}
              </h4>
              <p className="text-ink-light text-sm font-sans leading-relaxed" data-id="element-22">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-ink text-bone p-8 rounded-sm text-center max-w-3xl mx-auto" data-id="element-23">
          <Gift size={32} className="mx-auto mb-4 text-sage" data-id="element-24" />
          <h3 className="text-2xl md:text-3xl font-serif" data-id="element-25">
            💰 VALOR TOTAL DE LOS BONOS:{' '}
            <span className="line-through opacity-50" data-id="element-26">$56.000</span> ➔{' '}
            <span className="text-sage font-bold" data-id="element-27">¡GRATIS HOY!</span>
          </h3>
        </motion.div>
      </div>
    </section>;
}